"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
/* eslint-disable jsx-a11y/anchor-is-valid */
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_image_lightbox_1 = __importDefault(require("react-image-lightbox"));
require("react-image-lightbox/style.css");
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        image: {
            maxWidth: '100%',
            display: 'block',
            margin: '0 auto',
        },
        link: {
            textDecoration: 'none',
            color: 'inherit',
            '&:visited': {
                color: 'inherit',
            },
        },
        caption: {
            display: 'block',
            textAlign: 'center',
        },
    });
});
var LightboxImage = function (_a) {
    var alt = _a.alt, src = _a.src, _b = _a.maxHeight, maxHeight = _b === void 0 ? 300 : _b, _c = _a.disableHint, disableHint = _c === void 0 ? false : _c, other = __rest(_a, ["alt", "src", "maxHeight", "disableHint"]);
    var classes = exports.useStyles();
    var _d = __read(react_1.useState(false), 2), open = _d[0], setOpen = _d[1];
    function openLightbox(event) {
        event.preventDefault();
        setOpen(true);
    }
    return (react_1.default.createElement("div", __assign({}, other),
        react_1.default.createElement("a", { href: "#", onClick: openLightbox, className: classes.link },
            react_1.default.createElement("img", { src: src, alt: alt, className: classes.image, style: { maxHeight: maxHeight } }),
            !disableHint && (react_1.default.createElement(Typography_1.default, { variant: "caption", className: classes.caption }, "Click to enlarge"))),
        open && (react_1.default.createElement(react_image_lightbox_1.default, { reactModalStyle: { overlay: { zIndex: 999999999 } }, mainSrc: src, onCloseRequest: function () { return setOpen(false); } }))));
};
LightboxImage.defaultProps = {
    alt: '',
};
exports.default = LightboxImage;
//# sourceMappingURL=LightboxImage.js.map